"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pagination_1 = require("shared/pagination");
require("./ModuleApi");
const ModuleConstants_1 = require("./ModuleConstants");
const request_1 = __importDefault(require("@hotmart/request"));
class ModuleService {
    constructor() {
        this.getClassModules = async (classId, isExtraModule) => {
            return await (0, request_1.default)(ModuleConstants_1.ModuleEndpointKeys.GetModulesByClass, {
                id: classId,
                extra: isExtraModule
            });
        };
        this.getModules = async ({ isExtraModule = false, page = pagination_1.DEFAULT_FIRST_PAGE, size = pagination_1.DEFAULT_PAGE_SIZE }) => {
            return await (0, request_1.default)(ModuleConstants_1.ModuleEndpointKeys.GetModulesSummarized, {
                extra: isExtraModule,
                page,
                size
            });
        };
        this.getPages = (moduleId) => {
            return (0, request_1.default)(ModuleConstants_1.ModuleEndpointKeys.GetPages, {
                id: moduleId
            });
        };
    }
}
exports.default = new ModuleService();
